var _path, _path2, _path3, _path4, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgFaqEngine = function SvgFaqEngine(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 32 22"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#faq-engine_svg__a)",
    d: "M23.643 7.304h-2.502v14.471h2.502c.805 0 1.571-.31 2.144-.882a3 3 0 0 0 .892-2.153v-8.39a3.03 3.03 0 0 0-.892-2.153 3.03 3.03 0 0 0-2.144-.893",
    opacity: 0.6
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#faq-engine_svg__b)",
    d: "M1.665 9.07a.973.973 0 0 0-.97.97v5.926c0 .534.437.97.97.97s.97-.436.97-.97V10.04a.973.973 0 0 0-.97-.97"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#faq-engine_svg__c)",
    d: "M29.814 10.35h-.078c-.825 0-1.494.67-1.494 1.494v5.403c0 .825.669 1.493 1.494 1.493h.078c.824 0 1.493-.668 1.493-1.493v-5.403c0-.825-.669-1.494-1.493-1.494",
    opacity: 0.5
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#faq-engine_svg__d)",
    d: "M18.706.234h-5.81a1.3 1.3 0 0 0-1.29 1.31v.504c0 .727.573 1.309 1.29 1.309h1.368v1.406h-2.987c-.98 0-1.901.476-2.435 1.222l-1.27 1.581h-.36c-1.716 0-3.161 1.397-3.161 3.036v4.326a3.04 3.04 0 0 0 3.036 3.036h2.182l2.435 2.745a3.04 3.04 0 0 0 2.26 1.018l5.625.03v-1.94l-5.616-.03c-.31 0-.61-.135-.815-.368l-3.016-3.395H7.087a1.1 1.1 0 0 1-1.096-1.096v-4.326c0-.572.582-1.096 1.222-1.096h1.29l1.881-2.347c.204-.281.544-.456.893-.456h4.714c.737 0 1.338-.61 1.338-1.367V3.347h1.368a1.3 1.3 0 0 0 1.29-1.31v-.503c0-.728-.572-1.31-1.29-1.31z"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "faq-engine_svg__a",
    x1: 23.91,
    x2: 23.91,
    y1: 21.776,
    y2: 7.304,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A7DC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.485,
    stopColor: "#00CDDC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#01DCCF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "faq-engine_svg__b",
    x1: 1.665,
    x2: 1.665,
    y1: 16.936,
    y2: 9.07,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A7DC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.485,
    stopColor: "#00CDDC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#01DCCF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "faq-engine_svg__c",
    x1: 29.775,
    x2: 29.775,
    y1: 18.74,
    y2: 10.35,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A7DC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.485,
    stopColor: "#00CDDC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#01DCCF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "faq-engine_svg__d",
    x1: 12.019,
    x2: 12.019,
    y1: 21.756,
    y2: 0.224,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A7DC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.485,
    stopColor: "#00CDDC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#01DCCF"
  })))));
};
export default SvgFaqEngine;